import type { QuestionConfig } from './QuestionsConfig'

export const buildFilters = (
  questionConfigs: QuestionConfig[],
  selectedIndexes: (number | undefined)[],
  baseConditions: Record<string, unknown>[] = []
): Record<string, unknown> => {
  const conditions: Record<string, unknown>[] = [...baseConditions]

  questionConfigs.forEach((config, i) => {
    const selectedIndex = selectedIndexes[i]
    if (selectedIndex === undefined) {
      return
    }

    const filter = config.options[selectedIndex]?.filter
    if (!filter || typeof filter !== 'object' || Array.isArray(filter)) {
      return
    }

    conditions.push(filter)
  })

  return { and: conditions }
}
